import React, { useMemo } from 'react';
import DeviceMarker from './DeviceMarker';

const MarkerClusterComponent = ({ devicePositions, odcinkiData, setSelectedDevice, modelIcons, selectedDeviceId }) => {

  const validDeviceDistances = useMemo(() => {
    return devicePositions
      .filter(device => typeof device.latitude === 'number' && typeof device.longitude === 'number')
      .map(device => ({
        ...device,
        deviceId: device.deviceId || device.id,
        distanceOnPolyline: (10).toFixed(2),
      }));
  }, [devicePositions, odcinkiData]);

  const handleMarkerClick = (device, event) => {
    setSelectedDevice({ ...device });
  };

  return (
    <>
      {validDeviceDistances.map(device => (
        <DeviceMarker
          key={device.deviceId}
          device={device}
          onClick={handleMarkerClick}
          modelIcons={modelIcons}
          isSelected={device.deviceId === selectedDeviceId}
        />
      ))}
    </>
  );
};

export default MarkerClusterComponent;
